import * as React from 'react';

import { AppLoader } from '@eduzz/ui-layout';

const GlobalLoading = () => <AppLoader>{null}</AppLoader>;

export default GlobalLoading;
